import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth';
// import { Dashboard } from '../dashboard/Dashboard';
import { getMenu } from '../../../redux/actions/menu';
import { useNotification } from '../../../hooks/useNotification';
import { useTranslation } from 'react-i18next';
import { LayoutCharts } from '../../charts/layout/LayoutCharts';
import { useMenu } from '../../../hooks/useMenu';
import { safeParseJSON } from '../../../utils/jsonValidator';

export const LayoutHome = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sendNotification] = useNotification();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const [{ menu }] = useMenu();

    const [configuration, setconfiguration] = useState(null);

    const patharray = location.pathname.split('/').filter((x) => x);
    const pathnames = patharray.slice(1, patharray.length + 1);

    const NavigateAction = useCallback((item) => {
        navigate(item.config.path, { state: { config: item.config } });
    }, [navigate],)

    useEffect(() => {
        dispatch(getMenu(userSession.token));//Quitar cuando se termine proceso de acciones pendientes.
        if (userSession.pending_action) {
            const obj = JSON.parse(userSession.pending_action);
            sendNotification({
                msg: t('messages.pendingAction', { action: obj.action }),
                variant: 'info',
            });
            setTimeout(() => {
                NavigateAction(obj);
            }, 500);
        }
        else {
            navigate("/home");
        }
    }, [dispatch, navigate, userSession.token, userSession.pending_action]);

    const handleLinkBreadcrumbClick = (event, path) => {
        navigate(path);
    }

    const validateChangesPending = (path) => {
        handleLinkBreadcrumbClick(null, path);
    }

    useEffect(() => {
        if (menu.length > 0) {
            const data = menu.find(p => p.menu === "Inicio")
            const configuration = { configuration: data?.configuration, title: "Home" };//{data?.configuration}
            if (data.configuration) {
                setconfiguration(configuration);
            }
        }
    }, [menu, navigate])


    return (
        <>
            {configuration &&
                <LayoutCharts
                    conf={configuration}
                />
            }
        </>
        // // <Box sx={{ width: '100%' }}>
        // //     <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
        // <Breadcrumbs
        //             aria-label="breadcrumb"
        //             separator="›"
        //             sx={{ mb: 2 }}
        //         >
        //             <Link
        //                 underline="hover"
        //                 color="text.main"
        //                 sx={{ cursor: 'pointer' }}
        //                 onClick={() => validateChangesPending('/settings')}
        //             >
        //                 <Typography
        //                     sx={{ fontWeight: pathnames.length === 0 && "bold" }}
        //                 >
        //                     Home
        //                 </Typography>
        //             </Link>

        //         </Breadcrumbs> */}

        // //     </Box>
        // // </Box >
    )

}